module.exports = __webpack_public_path__ + "static/model-c27db56365149f2f0f754032bd323b72.mp4";